import { jsx as _jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import PopoverContent from "./components/PopoverContent";
import PopoverIcon from "./components/PopoverIcon";
const Popover = ({ children, open, onOpenChange, defaultOpen, modal }) => (_jsx(PopoverPrimitive.Root, { open: open, onOpenChange: onOpenChange, defaultOpen: defaultOpen, modal: modal, children: children }));
Popover.Trigger = PopoverPrimitive.Trigger;
Popover.Content = PopoverContent;
Popover.Icon = PopoverIcon;
export { PopoverContent, PopoverIcon };
export default Popover;
